module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 0);
}([function (e, t, n) {
  "use strict";

  function r(e) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  n.r(t);
  var o = new WeakMap(),
      i = new WeakMap();

  function u(e) {
    var t = o.get(e);
    return console.assert(null != t, "'this' is expected an Event object, but got", e), t;
  }

  function l(e) {
    null == e.passiveListener ? e.event.cancelable && (e.canceled = !0, "function" == typeof e.event.preventDefault && e.event.preventDefault()) : "undefined" != typeof console && "function" == typeof console.error && console.error("Unable to preventDefault inside passive event listener invocation.", e.passiveListener);
  }

  function a(e, t) {
    o.set(this, {
      eventTarget: e,
      event: t,
      eventPhase: 2,
      currentTarget: e,
      canceled: !1,
      stopped: !1,
      immediateStopped: !1,
      passiveListener: null,
      timeStamp: t.timeStamp || Date.now()
    }), Object.defineProperty(this, "isTrusted", {
      value: !1,
      enumerable: !0
    });

    for (var n = Object.keys(t), r = 0; r < n.length; ++r) {
      var i = n[r];
      i in this || Object.defineProperty(this, i, c(i));
    }
  }

  function c(e) {
    return {
      get: function get() {
        return u(this).event[e];
      },
      set: function set(t) {
        u(this).event[e] = t;
      },
      configurable: !0,
      enumerable: !0
    };
  }

  function f(e) {
    return {
      value: function value() {
        var t = u(this).event;
        return t[e].apply(t, arguments);
      },
      configurable: !0,
      enumerable: !0
    };
  }

  function p(e) {
    if (null == e || e === Object.prototype) return a;
    var t = i.get(e);
    return null == t && (t = function (e, t) {
      var n = Object.keys(t);
      if (0 === n.length) return e;

      function r(t, n) {
        e.call(this, t, n);
      }

      r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          configurable: !0,
          writable: !0
        }
      });

      for (var o = 0; o < n.length; ++o) {
        var i = n[o];

        if (!(i in e.prototype)) {
          var u = "function" == typeof Object.getOwnPropertyDescriptor(t, i).value;
          Object.defineProperty(r.prototype, i, u ? f(i) : c(i));
        }
      }

      return r;
    }(p(Object.getPrototypeOf(e)), e), i.set(e, t)), t;
  }

  function s(e) {
    return u(e).immediateStopped;
  }

  function y(e, t) {
    u(e).passiveListener = t;
  }

  a.prototype = {
    get type() {
      return u(this).event.type;
    },

    get target() {
      return u(this).eventTarget;
    },

    get currentTarget() {
      return u(this).currentTarget;
    },

    composedPath: function composedPath() {
      var e = u(this).currentTarget;
      return null == e ? [] : [e];
    },

    get NONE() {
      return 0;
    },

    get CAPTURING_PHASE() {
      return 1;
    },

    get AT_TARGET() {
      return 2;
    },

    get BUBBLING_PHASE() {
      return 3;
    },

    get eventPhase() {
      return u(this).eventPhase;
    },

    stopPropagation: function stopPropagation() {
      var e = u(this);
      e.stopped = !0, "function" == typeof e.event.stopPropagation && e.event.stopPropagation();
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = u(this);
      e.stopped = !0, e.immediateStopped = !0, "function" == typeof e.event.stopImmediatePropagation && e.event.stopImmediatePropagation();
    },

    get bubbles() {
      return Boolean(u(this).event.bubbles);
    },

    get cancelable() {
      return Boolean(u(this).event.cancelable);
    },

    preventDefault: function preventDefault() {
      l(u(this));
    },

    get defaultPrevented() {
      return u(this).canceled;
    },

    get composed() {
      return Boolean(u(this).event.composed);
    },

    get timeStamp() {
      return u(this).timeStamp;
    },

    get srcElement() {
      return u(this).eventTarget;
    },

    get cancelBubble() {
      return u(this).stopped;
    },

    set cancelBubble(e) {
      if (e) {
        var t = u(this);
        t.stopped = !0, "boolean" == typeof t.event.cancelBubble && (t.event.cancelBubble = !0);
      }
    },

    get returnValue() {
      return !u(this).canceled;
    },

    set returnValue(e) {
      e || l(u(this));
    },

    initEvent: function initEvent() {}
  }, Object.defineProperty(a.prototype, "constructor", {
    value: a,
    configurable: !0,
    writable: !0
  }), "undefined" != typeof window && void 0 !== window.Event && (Object.setPrototypeOf(a.prototype, window.Event.prototype), i.set(window.Event.prototype, a));
  var b = new WeakMap();

  function v(e) {
    return null !== e && "object" === r(e);
  }

  function d(e) {
    var t = b.get(e);
    if (null == t) throw new TypeError("'this' is expected an EventTarget object, but got another value.");
    return t;
  }

  function g(e, t) {
    Object.defineProperty(e, "on".concat(t), function (e) {
      return {
        get: function get() {
          for (var t = d(this).get(e); null != t;) {
            if (3 === t.listenerType) return t.listener;
            t = t.next;
          }

          return null;
        },
        set: function set(t) {
          "function" == typeof t || v(t) || (t = null);

          for (var n = d(this), r = null, o = n.get(e); null != o;) {
            3 === o.listenerType ? null !== r ? r.next = o.next : null !== o.next ? n.set(e, o.next) : n.delete(e) : r = o, o = o.next;
          }

          if (null !== t) {
            var i = {
              listener: t,
              listenerType: 3,
              passive: !1,
              once: !1,
              next: null
            };
            null === r ? n.set(e, i) : r.next = i;
          }
        },
        configurable: !0,
        enumerable: !0
      };
    }(t));
  }

  function h(e) {
    function t() {
      m.call(this);
    }

    t.prototype = Object.create(m.prototype, {
      constructor: {
        value: t,
        configurable: !0,
        writable: !0
      }
    });

    for (var n = 0; n < e.length; ++n) {
      g(t.prototype, e[n]);
    }

    return t;
  }

  function m() {
    if (!(this instanceof m)) {
      if (1 === arguments.length && Array.isArray(arguments[0])) return h(arguments[0]);

      if (arguments.length > 0) {
        for (var e = new Array(arguments.length), t = 0; t < arguments.length; ++t) {
          e[t] = arguments[t];
        }

        return h(e);
      }

      throw new TypeError("Cannot call a class as a function");
    }

    b.set(this, new Map());
  }

  m.prototype = {
    addEventListener: function addEventListener(e, t, n) {
      if (null != t) {
        if ("function" != typeof t && !v(t)) throw new TypeError("'listener' should be a function or an object.");
        var r = d(this),
            o = v(n),
            i = (o ? Boolean(n.capture) : Boolean(n)) ? 1 : 2,
            u = {
          listener: t,
          listenerType: i,
          passive: o && Boolean(n.passive),
          once: o && Boolean(n.once),
          next: null
        },
            l = r.get(e);

        if (void 0 !== l) {
          for (var a = null; null != l;) {
            if (l.listener === t && l.listenerType === i) return;
            a = l, l = l.next;
          }

          a.next = u;
        } else r.set(e, u);
      }
    },
    removeEventListener: function removeEventListener(e, t, n) {
      if (null != t) for (var r = d(this), o = (v(n) ? Boolean(n.capture) : Boolean(n)) ? 1 : 2, i = null, u = r.get(e); null != u;) {
        if (u.listener === t && u.listenerType === o) return void (null !== i ? i.next = u.next : null !== u.next ? r.set(e, u.next) : r.delete(e));
        i = u, u = u.next;
      }
    },
    dispatchEvent: function dispatchEvent(e) {
      if (null == e || "string" != typeof e.type) throw new TypeError('"event.type" should be a string.');
      var t = d(this),
          n = e.type,
          r = t.get(n);
      if (null == r) return !0;

      for (var o = function (e, t) {
        return new (p(Object.getPrototypeOf(t)))(e, t);
      }(this, e), i = null; null != r;) {
        if (r.once ? null !== i ? i.next = r.next : null !== r.next ? t.set(n, r.next) : t.delete(n) : i = r, y(o, r.passive ? r.listener : null), "function" == typeof r.listener) try {
          r.listener.call(this, o);
        } catch (e) {
          "undefined" != typeof console && "function" == typeof console.error && console.error(e);
        } else 3 !== r.listenerType && "function" == typeof r.listener.handleEvent && r.listener.handleEvent(o);
        if (s(o)) break;
        r = r.next;
      }

      return y(o, null), function (e, t) {
        u(e).eventPhase = t;
      }(o, 0), function (e, t) {
        u(e).currentTarget = t;
      }(o, null), !o.defaultPrevented;
    }
  }, Object.defineProperty(m.prototype, "constructor", {
    value: m,
    configurable: !0,
    writable: !0
  }), "undefined" != typeof window && void 0 !== window.EventTarget && Object.setPrototypeOf(m.prototype, window.EventTarget.prototype);

  function w(e) {
    return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function O(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function P(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function j(e, t, n) {
    return t && P(e.prototype, t), n && P(e, n), e;
  }

  function S(e, t) {
    return (S = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function T(e, t) {
    return !t || "object" !== w(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function x() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function E(e) {
    return (E = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var A = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && S(e, t);
    }(r, e);
    var t,
        n = (t = r, function () {
      var e,
          n = E(t);

      if (x()) {
        var r = E(this).constructor;
        e = Reflect.construct(n, arguments, r);
      } else e = n.apply(this, arguments);

      return T(this, e);
    });

    function r() {
      throw O(this, r), n.call(this), new TypeError("AbortSignal cannot be constructed directly");
    }

    return j(r, [{
      key: "aborted",
      get: function get() {
        var e = _.get(this);

        if ("boolean" != typeof e) throw new TypeError("Expected 'this' to be an 'AbortSignal' object, but got ".concat(null === this ? "null" : w(this)));
        return e;
      }
    }]), r;
  }(m);

  g(A.prototype, "abort");

  var _ = new WeakMap();

  Object.defineProperties(A.prototype, {
    aborted: {
      enumerable: !0
    }
  }), "function" == typeof Symbol && "symbol" === w(Symbol.toStringTag) && Object.defineProperty(A.prototype, Symbol.toStringTag, {
    configurable: !0,
    value: "AbortSignal"
  });

  var B = function () {
    function e() {
      var t;
      O(this, e), k.set(this, (t = Object.create(A.prototype), m.call(t), _.set(t, !1), t));
    }

    return j(e, [{
      key: "abort",
      value: function value() {
        var e;
        e = M(this), !1 === _.get(e) && (_.set(e, !0), e.dispatchEvent({
          type: "abort"
        }));
      }
    }, {
      key: "signal",
      get: function get() {
        return M(this);
      }
    }]), e;
  }(),
      k = new WeakMap();

  function M(e) {
    var t = k.get(e);
    if (null == t) throw new TypeError("Expected 'this' to be an 'AbortController' object, but got ".concat(null === e ? "null" : w(e)));
    return t;
  }

  Object.defineProperties(B.prototype, {
    signal: {
      enumerable: !0
    },
    abort: {
      enumerable: !0
    }
  }), "function" == typeof Symbol && "symbol" === w(Symbol.toStringTag) && Object.defineProperty(B.prototype, Symbol.toStringTag, {
    configurable: !0,
    value: "AbortController"
  });
  var D = B;
  n.d(t, "AbortController", function () {
    return R;
  }), n.d(t, "AbortSignal", function () {
    return C;
  });
  var R = ("undefined" == typeof window ? {} : window).AbortController || D,
      C = ("undefined" == typeof window ? {} : window).AbortSignal || A;
  t.default = R;
}]);